export default "__VITE_ASSET__BNPq6peA__"